import { CircularProgress, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchResumeUrl } from "../../utils/actionUtils";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const MyCustomDocRenderer = ({ mainState: { currentDocument } }) => {
  if (!currentDocument) return null;

  return (
    <div>
      <img src={currentDocument.fileData} />
    </div>
  );
};

MyCustomDocRenderer.fileTypes = ["doc", "docx"];
MyCustomDocRenderer.weight = 1;

const ResumePreview = ({ resumeId, fileType }) => {
  const dispatch = useDispatch();
  const accountData = useSelector((state) => state.auth.accountData);
  const resumeUrls = useSelector((state) => state.apply.resumeUrls);
  useEffect(() => {
    if (resumeUrls[resumeId]) return;
    fetchResumeUrl(dispatch, accountData, resumeId);
  }, [resumeId]);
  if (!resumeUrls[resumeId]) {
    return <CircularProgress />;
  }
  const src = resumeUrls[resumeId];
  const docs = [{ uri: src, fileType }];
  if (fileType === "pdf") {
    return (
      <object
        data={src}
        type="application/pdf"
        width="100%"
        height="712px"
        style={{
          paddingTop: "12px",
        }}>
        <p>
          Unable to display PDF file. <a href={src}>Download</a> or{" "}
          <a href="#" onClick={() => window.location.reload()}>
            refresh the page
          </a>
          .
        </p>
      </object>
    );
  } else if (fileType === "txt") {
    return (
      <object
        data={src}
        type="text/plain"
        width="100%"
        height="712px"
        style={{
          paddingTop: "12px",
        }}>
        <p>
          Unable to display TXT file. <a href={src}>Download</a> or{" "}
          <a href="#" onClick={() => window.location.reload()}>
            refresh the page
          </a>
          .
        </p>
      </object>
    );
  }
  return (
    <Box sx={{ width: "100%", height: "712px", paddingTop: "10px" }}>
      <DocViewer
        documents={docs}
        pluginRenderers={DocViewerRenderers}
        style={{
          height: "100%",
        }}
        config={{
          header: {
            disableHeader: true,
            disableFileName: false,
            retainURLParams: false,
          },
        }}
      />
    </Box>
  );
  //   return <a src={src} />;
  // return
};

export default ResumePreview;
